/* BPBD: independent before/after sliders and optional multi-pair carousel. */
(function(){
  function setupStage(stage){
    var range=stage.querySelector('[data-bpbd-decant-range]');
    if(!range||range.dataset.bpbdReady==='true')return;
    range.dataset.bpbdReady='true';
    function update(){
      var value=Math.max(0,Math.min(100,Number(range.value)||0));
      stage.style.setProperty('--bpbd-split',value+'%');
      range.setAttribute('aria-valuetext',value+'% of the original bottle image is visible');
    }
    range.addEventListener('input',update);
    range.addEventListener('change',update);
    update();
  }
  function setupCarousel(root){
    if(root.dataset.bpbdCarouselReady==='true')return;
    root.dataset.bpbdCarouselReady='true';
    var slides=Array.prototype.slice.call(root.querySelectorAll('[data-bpbd-carousel-slide]'));
    var dots=Array.prototype.slice.call(root.querySelectorAll('[data-bpbd-carousel-dot]'));
    var prev=root.querySelector('[data-bpbd-carousel-prev]');
    var next=root.querySelector('[data-bpbd-carousel-next]');
    var status=root.querySelector('[data-bpbd-carousel-status]');
    var index=0;
    if(slides.length<2)return;
    function show(n){
      index=(n+slides.length)%slides.length;
      slides.forEach(function(slide,i){
        slide.hidden=(i!==index);
        slide.setAttribute('aria-hidden',i===index?'false':'true');
      });
      dots.forEach(function(dot,i){
        var active=i===index;
        dot.classList.toggle('is-active',active);
        dot.setAttribute('aria-pressed',active?'true':'false');
      });
      if(status)status.textContent=(index+1)+' / '+slides.length;
    }
    if(prev)prev.addEventListener('click',function(){show(index-1)});
    if(next)next.addEventListener('click',function(){show(index+1)});
    dots.forEach(function(dot,i){dot.addEventListener('click',function(){show(i)})});
    // Fast horizontal touch swipes change slide; slow drag still adjusts image comparison.
    var start=null;
    root.addEventListener('touchstart',function(e){
      if(!e.touches||e.touches.length!==1||e.target.closest('button')){start=null;return}
      start={x:e.touches[0].clientX,y:e.touches[0].clientY,time:Date.now()};
    },{passive:true});
    root.addEventListener('touchend',function(e){
      if(!start||!e.changedTouches||e.changedTouches.length!==1)return;
      var dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y,ms=Date.now()-start.time;
      start=null;
      if(Math.abs(dx)>=70&&Math.abs(dx)>Math.abs(dy)*1.5&&ms<=450)show(index+(dx<0?1:-1));
    },{passive:true});
    root.addEventListener('touchcancel',function(){start=null},{passive:true});
    show(0);
  }
  function init(scope){
    if(!scope||!scope.querySelectorAll)return;
    scope.querySelectorAll('[data-bpbd-decant-stage]').forEach(setupStage);
    scope.querySelectorAll('[data-bpbd-comparison-carousel]').forEach(setupCarousel);
    if(scope.matches&&scope.matches('[data-bpbd-comparison-carousel]'))setupCarousel(scope);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});
  else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();